import {
  AWXConnectedAccountTransferActivityEventStatus,
  AWXDepositActivityStatus,
  AWXTransferActivityEventStatus,
  TransactionStatus,
} from '@ankor-io/common/types/transaction/transaction'
import { AWXCardActivityEventStatus } from '@ankor-io/common/types/transaction/transaction'

export const getCardTransactionStatusColour = (status: AWXCardActivityEventStatus) => {
  switch (status) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return 'green'
    case AWXCardActivityEventStatus.FAILED:
      return 'red'
    case AWXCardActivityEventStatus.PENDING:
      return 'yellow'
    case AWXCardActivityEventStatus.REFUNDED:
      return 'gray'
    default:
      return 'gray'
  }
}

export const getStatusColour = (status: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.SUBMITTED:
      return 'primary'
    case TransactionStatus.INCOMPLETE:
      return 'yellow'
    case TransactionStatus.PARTIALLY_APPROVED:
    case TransactionStatus.APPROVED:
      return 'green'
    case TransactionStatus.REJECTED:
      return 'red'
    default:
      return 'gray'
  }
}

export const getStatusText = (status: TransactionStatus): string => {
  switch (status) {
    case TransactionStatus.INCOMPLETE:
      return 'Incomplete'
    case TransactionStatus.SUBMITTED:
      return 'Ready for review'
    case TransactionStatus.PARTIALLY_APPROVED:
      return 'Partially Approved'
    case TransactionStatus.APPROVED:
      return 'Approved'
    case TransactionStatus.REJECTED:
      return 'Denied'
    default:
      return status
  }
}

export const getTransferStatusText = (status: AWXTransferActivityEventStatus) => {
  switch (status) {
    case AWXTransferActivityEventStatus.IN_APPROVAL:
      return 'In Approval'
    case AWXTransferActivityEventStatus.APPROVAL_RECALLED:
      return 'Approval Recalled'
    case AWXTransferActivityEventStatus.APPROVAL_REJECTED:
      return 'Approval Rejected'
    case AWXTransferActivityEventStatus.APPROVAL_BLOCKED:
      return 'Approval Blocked'
    case AWXTransferActivityEventStatus.SCHEDULED:
      return 'Scheduled'
    case AWXTransferActivityEventStatus.OVERDUE:
      return 'Overdue'
    case AWXTransferActivityEventStatus.PROCESSING:
      return 'Processing'
    case AWXTransferActivityEventStatus.SENT:
      return 'Sent'
    case AWXTransferActivityEventStatus.PAID:
      return 'Paid'
    case AWXTransferActivityEventStatus.FAILED:
      return 'Failed'
    case AWXTransferActivityEventStatus.CANCELLED:
      return 'Cancelled'
    default:
      return status
  }
}

export const getTransferStatusColour = (status: AWXTransferActivityEventStatus) => {
  switch (status) {
    case AWXTransferActivityEventStatus.IN_APPROVAL:
      return 'yellow'
    case AWXTransferActivityEventStatus.APPROVAL_RECALLED:
      return 'yellow'
    case AWXTransferActivityEventStatus.APPROVAL_REJECTED:
      return 'red'
    case AWXTransferActivityEventStatus.APPROVAL_BLOCKED:
      return 'red'
    case AWXTransferActivityEventStatus.SCHEDULED:
      return 'yellow'
    case AWXTransferActivityEventStatus.OVERDUE:
      return 'red'
    case AWXTransferActivityEventStatus.PROCESSING:
      return 'yellow'
    case AWXTransferActivityEventStatus.SENT:
      return 'yellow'
    case AWXTransferActivityEventStatus.PAID:
      return 'green'
    case AWXTransferActivityEventStatus.FAILED:
      return 'red'
    case AWXTransferActivityEventStatus.CANCELLED:
      return 'red'
    default:
      return 'gray'
  }
}

export const getDepositStatusText = (status: AWXDepositActivityStatus) => {
  switch (status) {
    case AWXDepositActivityStatus.PENDING:
      return 'Pending'
    case AWXDepositActivityStatus.SETTLED:
      return 'Settled'
    case AWXDepositActivityStatus.REJECTED:
      return 'Rejected'
    case AWXDepositActivityStatus.REVERSED:
      return 'Reversed'
    default:
      return status
  }
}

export const getDepositStatusColour = (status: AWXDepositActivityStatus) => {
  switch (status) {
    case AWXDepositActivityStatus.PENDING:
      return 'yellow'
    case AWXDepositActivityStatus.SETTLED:
      return 'green'
    case AWXDepositActivityStatus.REJECTED:
      return 'red'
    case AWXDepositActivityStatus.REVERSED:
      return 'blue'
    default:
      return 'gray'
  }
}

export const getConnectedAccountTransferStatusText = (status: AWXConnectedAccountTransferActivityEventStatus) => {
  switch (status) {
    case AWXConnectedAccountTransferActivityEventStatus.NEW:
      return 'New'
    case AWXConnectedAccountTransferActivityEventStatus.SETTLED:
      return 'Settled'
    case AWXConnectedAccountTransferActivityEventStatus.PENDING:
      return 'Pending'
    case AWXConnectedAccountTransferActivityEventStatus.SUSPENDED:
      return 'Suspended'
    case AWXConnectedAccountTransferActivityEventStatus.FAILED:
      return 'Failed'
    default:
      return status
  }
}

export const getConnectedAccountTransferStatusColour = (status: AWXConnectedAccountTransferActivityEventStatus) => {
  switch (status) {
    case AWXConnectedAccountTransferActivityEventStatus.SETTLED:
      return 'green'
    case AWXConnectedAccountTransferActivityEventStatus.NEW:
    case AWXConnectedAccountTransferActivityEventStatus.PENDING:
    case AWXConnectedAccountTransferActivityEventStatus.SUSPENDED:
      return 'yellow'
    case AWXConnectedAccountTransferActivityEventStatus.FAILED:
      return 'red'
    default:
      return 'gray'
  }
}
